import { asList2ho2pewtsfvv as asList } from '../../../collections/_ArraysJs.mjs';
import { KTypeImpl24ni3lyofhkxw as KTypeImpl } from '../../KTypeImpl.mjs';
import {
  KVariance_IN_getInstancepls6ln99ee99 as KVariance_IN_getInstance,
  KVariance_OUT_getInstance2yv35n60oigpi as KVariance_OUT_getInstance,
  KVariance_INVARIANT_getInstances2wjy4dm54do as KVariance_INVARIANT_getInstance,
} from '../../KVariance.mjs';
import { KTypeParameterImpl2de0szhlrzcmf as KTypeParameterImpl } from './KTypeParameterImpl.mjs';
import { Companion_getInstance36z5brpf9mjyr as Companion_getInstance } from '../../KTypeProjection.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function createKType(classifier, arguments_0, isMarkedNullable) {
  return new (KTypeImpl())(classifier, asList(arguments_0), isMarkedNullable);
}
function createKTypeParameter(name, upperBounds, variance, isReified, container) {
  var kVariance;
  switch (variance) {
    case 'in':
      kVariance = KVariance_IN_getInstance();
      break;
    case 'out':
      kVariance = KVariance_OUT_getInstance();
      break;
    default:
      kVariance = KVariance_INVARIANT_getInstance();
      break;
  }
  return new (KTypeParameterImpl())(name, asList(upperBounds), kVariance, isReified, container);
}
function getStarKTypeProjection() {
  return Companion_getInstance().kf();
}
function createInvariantKTypeProjection(type) {
  return Companion_getInstance().lf(type);
}
//region block: exports
export {
  createInvariantKTypeProjection as createInvariantKTypeProjection3h5364czc0a8w,
  createKTypeParameter as createKTypeParameter16gw97ll17xmd,
  createKType as createKType31ecntyyaay3k,
  getStarKTypeProjection as getStarKTypeProjection316vzroubdy0t,
};
//endregion

//# sourceMappingURL=KTypeHelpers.mjs.map
